import type { PopupContext } from "./_types";

import { createContext, useContext } from "react";

export const Context = createContext({} as PopupContext);

export const usePopupContext = () => useContext(Context);
